export enum TipoSerieReinf {
  SERIE_2000 = "SERIE_2000",
  SERIE_4000 = "SERIE_4000",
}
